import { cmsStore } from 'app/store';
import { getAccountInfo } from 'shared/lib/reducers/cms-account.reducer';
/** Sync read after account has been loaded (e.g. from store bootstrap). */
export function selectCmsApproverId(state) {
    const id = state.cmsAccount.account?.id;
    if (id == null || id === '') {
        throw new Error('Approver ID not found from account');
    }
    return String(id);
}
/**
 * Ensures `users/api/account` was fetched, then returns the approver user id string.
 * Prefers Redux `cmsAccount` populated at app bootstrap — only dispatches fetch when missing.
 */
export async function getCmsAccountApproverId() {
    const snapshot = cmsStore.getState();
    if (snapshot.cmsAccount.account?.id != null && snapshot.cmsAccount.account.id !== '') {
        return selectCmsApproverId(snapshot);
    }
    await cmsStore.dispatch(getAccountInfo());
    return selectCmsApproverId(cmsStore.getState());
}
